import { StagedFeature, ToggleFeature } from '../types/accessibility.types';

export function isToggleFeature(value: string): value is ToggleFeature {
	return ['darkMode', 'highlightLinks', 'hideImages', 'pauseAnimation', 'dyslexicFont', 'bigCursor'].includes(value as ToggleFeature);
}

export function isStagedFeature(value: string): value is StagedFeature {
	return ['textSize', 'lineHeight', 'contrast', 'saturation'].includes(value as StagedFeature);
}
